<!-- 行動呼籲 start -->
<template>
  <b-button
    v-if="info.ctaName !== ''"
    class="px-4 font-size-md my-2"
    :style="{background: `rgba(${info.ctaColor}, 0.75)`,'border-color': `rgba(${info.ctaColor}, 1.0)` ,color: `rgba(${info.ctaColor === '255,255,255' ? '45,167,193' :'255,255,255'},1.0)`}"
    @click="clickCta"
  >
    {{ info.ctaName }}
  </b-button><!-- 行動呼籲按鈕, 形狀：pill/空值/squared -->
</template>
<!-- 行動呼籲 end -->

<script>
export default {
  props: {
    // 娛樂活動資料(刮刮樂...)
    info: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // 按下行動呼籲按鈕
    clickCta() {
      const vm = this;
      switch (vm.info.ctaActionType) {
        case 'URL':
          // 打開連結
          window.open(vm.info.ctaActionValue);
          break;
        default:
          break;
      }
    },
  },
};
</script>
